import RSVPForm from "./RSVPForm";
import useReveal from "@/hooks/useReveal";

export default function RSVPSection() {
  const ref = useReveal();
  return (
    <section
      id="rsvp"
      className="relative py-24 sm:py-32 lg:py-40 px-6"
      data-testid="rsvp-section"
    >
      <div className="max-w-3xl mx-auto">
        <div ref={ref} className="reveal text-center">
          <p className="label-eyebrow">With love, we ask</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl md:text-6xl text-[#4A5346] mt-6">
            Will you join us?
          </h2>
          <p className="text-[#757E70] mt-6 leading-relaxed max-w-xl mx-auto">
            Kindly respond by 15 August, 2026. Whether for one day or all three,
            your presence will be cherished.
          </p>
        </div>

        <div className="mt-16">
          <RSVPForm />
        </div>
      </div>
    </section>
  );
}
